export type FileTypeKind = 'pdf' | 'spreadsheet' | 'document' | 'text' | 'generic';

export function fileExtension(fileName: string): string {
  const trimmed = fileName.trim().toLowerCase();
  if (!trimmed.includes('.')) return '';
  return trimmed.slice(trimmed.lastIndexOf('.') + 1);
}

export function fileTypeKind(fileName: string, contentType?: string): FileTypeKind {
  const ext = fileExtension(fileName);
  const mime = (contentType ?? '').toLowerCase();

  if (ext === 'pdf' || mime === 'application/pdf') return 'pdf';
  if (['xls', 'xlsx', 'csv'].includes(ext) || mime.includes('spreadsheet') || mime.includes('excel')) {
    return 'spreadsheet';
  }
  if (['doc', 'docx'].includes(ext) || mime.includes('word')) return 'document';
  if (['txt', 'md', 'json', 'tsv', 'log'].includes(ext) || mime.startsWith('text/')) return 'text';
  return 'generic';
}

export function fileTypeLabel(kind: FileTypeKind): string {
  switch (kind) {
    case 'pdf':
      return 'PDF';
    case 'spreadsheet':
      return 'Spreadsheet';
    case 'document':
      return 'Document';
    case 'text':
      return 'Text';
    default:
      return 'File';
  }
}

export function fileTypeIconSrc(kind: FileTypeKind, isDarkMode: boolean): string {
  switch (kind) {
    case 'pdf':
      return isDarkMode ? '/assets/icons/text.document.svg' : '/assets/icons/text.document.black.svg';
    case 'spreadsheet':
      return isDarkMode ? '/assets/icons/list.number.svg' : '/assets/icons/list.number.black.svg';
    case 'document':
      return isDarkMode
        ? '/assets/icons/document.on.document.svg'
        : '/assets/icons/document.on.document.black.svg';
    case 'text':
      return isDarkMode ? '/assets/icons/text.document.svg' : '/assets/icons/text.document.black.svg';
    default:
      return isDarkMode
        ? '/assets/icons/document.on.document.svg'
        : '/assets/icons/document.on.document.black.svg';
  }
}

export function formatFileSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(bytes < 10_240 ? 1 : 0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
